import { useMemo } from 'react';

import { IcExclamationCircleFilled } from '@proton/icons/icons/IcExclamationCircleFilled';
import isTruthy from '@proton/utils/isTruthy';

import useRecoveryNotification from '../../../../hooks/useRecoveryNotification';
import useSettingsLink from '../../../link/useSettingsLink';
import DrawerAppSection from '../shared/DrawerAppSection';
import QuickSettingsReminder from './QuickSettingsReminder';
import type { QuickSettingsReminders } from './interface';

interface Props {
    inAppReminders?: QuickSettingsReminders[];
}
const QuickSettingsRemindersSection = ({ inAppReminders = [] }: Props) => {
    const goToSettings = useSettingsLink();

    const insideDropdownRecoveryNotification = useRecoveryNotification(false, true);

    const reminders: QuickSettingsReminders[] = useMemo(() => {
        const recoveryNotificationReminder: QuickSettingsReminders | undefined = insideDropdownRecoveryNotification
            ? {
                  text: insideDropdownRecoveryNotification.text,
                  icon: IcExclamationCircleFilled,
                  color: insideDropdownRecoveryNotification.color,
                  callback: () => goToSettings(insideDropdownRecoveryNotification.path),
                  testID: 'recovery',
              }
            : undefined;

        return [...inAppReminders, recoveryNotificationReminder].filter(isTruthy);
    }, [insideDropdownRecoveryNotification, inAppReminders]);

    if (reminders.length === 0) {
        return null;
    }

    return (
        <DrawerAppSection>
            {reminders.map((reminder) => {
                return (
                    <QuickSettingsReminder
                        reminder={reminder}
                        key={reminder.text}
                        data-testid={`drawer-quick-settings:${reminder.testID}-button`}
                    />
                );
            })}
        </DrawerAppSection>
    );
};

export default QuickSettingsRemindersSection;
